import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_63: FaireProductEntity = {
  token: "legacy_prod_abbott-63",
  type: "product",
  name: "Autumn Harvest Lined Notebook 6×8 L",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/51f76ef01352a8debb40dd258794a655182bb7eb08b71c3646699a1be3940684.jpeg",
  priceDollars: 9,
  msrpDollars: 14,
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_stationery-writing"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
